/**
 * Shared “grant service user or paste read-only PAT” fields (same UX as Scans).
 */
import React from 'react';
import ServiceAccountAccessSteps from './ServiceAccountAccessSteps';

const RepoAccessFields = ({
  serviceUser,
  accessToken,
  onAccessTokenChange,
  disabled = false,
  idPrefix = 'repo-access',
  hintExtra = null,
}) => {
  return (
    <div className="garage-form-group repo-access-fields">
      <label>Repository access</label>
      <ServiceAccountAccessSteps serviceUser={serviceUser} />
      {hintExtra ? (
        <p className="garage-field-hint" style={{ marginTop: '0.75rem' }}>
          {hintExtra}
        </p>
      ) : null}
      <label htmlFor={`${idPrefix}-token`} style={{ display: 'block', marginTop: '0.75rem' }}>
        Access token <span className="garage-optional">(Optional)</span>
      </label>
      <input
        id={`${idPrefix}-token`}
        type="password"
        autoComplete="off"
        className="garage-input"
        value={accessToken}
        onChange={(e) => onAccessTokenChange(e.target.value)}
        placeholder="Leave blank after inviting the service account as Reporter"
        disabled={disabled}
      />
    </div>
  );
};

export default RepoAccessFields;
